import React, { type FC } from 'react';
import classNames from 'classnames';
import { useToolNavigationRoleSwitcherProvider } from './ToolNavigationRoleSwitcherProvider';
import classes from '../styles/index.module.css';
import { codes } from '../../../data/translations/codes';
import { useTranslationAPI } from '../../translations';

export const ToolNavigationRoleSwitcher: FC = () => {
	const { translate } = useTranslationAPI();
	const { hasUserNavigation, hasAdminNavigation, switchToUser, switchToAdmin, isAdmin } =
		useToolNavigationRoleSwitcherProvider();

	const btnUserClasses = classNames(classes.switcherBtn, {
		[classes.switcherBtn_active]: !isAdmin,
	});

	const btnAdminClasses = classNames(classes.switcherBtn, {
		[classes.switcherBtn_active]: isAdmin,
	});

	return (
		<div className={classes.toolNavigation__roleSwitcher}>
			{hasUserNavigation && (
				<button
					className={btnUserClasses}
					type='button'
					onClick={switchToUser}
					data-tool-navigation-list-type='user'
					data-testid='tool-navigation-user-role-switcher'
					aria-selected={!isAdmin}
				>
					{translate(codes.user.singular)}
				</button>
			)}
			{hasAdminNavigation && (
				<button
					className={btnAdminClasses}
					type='button'
					onClick={switchToAdmin}
					data-tool-navigation-list-type='admin'
					data-testid='tool-navigation-admin-role-switcher'
					aria-selected={isAdmin}
				>
					{translate(codes.navigation.admin)}
				</button>
			)}
		</div>
	);
};
